export default {
  users: [],
  owners: [],
  guardians: [],
  parents: [],
}
